<div class="bc-tabs">
    <div class="bc-tab" *ngFor="let tab of tabs" [class.selected]="isTabSelected(tab)" (click)="selectTab(tab)">
        {{ tab }}
    </div>
</div>